import React from "react"
import PropTypes from "prop-types"
import Image from "gatsby-image"
import "../css/project.css"

import { FaGithubSquare, FaShareSquare} from 'react-icons/fa'



import styled from "styled-components"

const Project = ({ description, title, github, url, stack, image, index}) => {
  return <Wrapper>
  <Image fluid={image.childImageSharp.fluid} className="img"/>
  <div className="info">
    {
      stack.map((item)=>{
        return <span key={item.id} className="category">{item.name}</span>
      })
    }
    
    <h3>{title}</h3>
    <div className="underline"></div>
    <p>{description}</p>
    <footer>
      <div className="project-link">
        <a href={github} target="blank"><FaGithubSquare className="project-icon" /></a>
        <a href={url} target="blank"><FaShareSquare className="project-icon" /></a>
      </div>
    </footer>
  </div>
</Wrapper>
}

Project.propTypes = {
  title: PropTypes.string.isRequired,
  image: PropTypes.object.isRequired,
  stack: PropTypes.arrayOf(PropTypes.object).isRequired
}

const Wrapper = styled.article`
  margin-bottom: 3rem;
  .info { 
    text-align: center;
    margin-top: 20px;
  }
  .img {
    margin-bottom: 1rem;
    border-radius: var(--radius);
    height: 17rem;
  }
  .category {
    display: inline-block;
    margin-bottom: 1rem;
    background: var(--clr-grey-10);
    background: var(--clr-primary-5);
    padding: 0.25rem 0.5rem;
    text-transform: uppercase;
    font-weight: 700;
    border-radius: var(--radius);
    letter-spacing: var(--spacing);
    color: var(--clr-grey-5);
    color: white;
  }
  h3 {
    font-weight: 200;
    margin-bottom: 1rem;
    text-transform: initial;
    font-size: 1em;
  }
  .underline {
    width: 5rem;
    height: 1px;
    background: var(--clr-grey-9);
    margin: 0 auto;
    margin-bottom: 1rem;
  }
  p {
    color: var(--clr-grey-5);
    line-height: 1.8;
  }
  .link {
    text-transform: uppercase;
    letter-spacing: var(--spacing);
    font-weight: 700;
    color: var(--clr-primary-5);
    padding-bottom: 0.1rem;
    display: flex;
    align-items: center;
    svg {
      margin-left: 0.25rem;
      font-size: 1.2rem;
    }
  }
  .link:hover {
    border-color: var(--clr-primary-8);
    color: var(--clr-primary-8);
  }
  footer {
    margin-top: 2rem;
    padding-top: 1rem;
    border-top: 1px solid var(--clr-grey-9);
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: var(--clr-grey-5);
    & .date {
      display: flex;
      align-items: center;
      & .icon {
        color: var(--clr-primary-5);
        margin-right: 0.5rem;
      }
    }
  }
  @media (min-width: 600px) {
    .img {
      height: 20rem;
    }
  }
  @media (min-width: 800px) {
    .img {
      height: 25rem;
    }
  }
  @media (min-width: 992px) {
    & {
      display: grid;
      grid-template-columns: 30rem 1fr;
      column-gap: 1.5rem;
      .info {
        text-align: left;
      }
      .img {
        height: 100%;
        max-height: 20rem;
      }
      .underline {
        margin-left: 0;
        margin-right: 0;
      }
    }
  }
`

export default Project
